// extracted by mini-css-extract-plugin
export default {"button":"ModerateCardDetailsContainer-button-d246dff9dcef8f297e5285fc7c213015","decisionIcon":"ModerateCardDetailsContainer-decisionIcon-8d78e4692bac3fb10c938fc90bc6d50d"};